export const testimonials = [
  {
    id: 't001',
    name: '李明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%20warm%20lighting%20clean%20simple%20background%20friendly%20smile%20professional%20photography&width=80&height=80&seq=mv-test-001&orientation=squarish',
    role: '影视爱好者',
    rating: 5,
    content: '自从用了蘑菇视频网页版，再也不用纠结下载哪个App了。电脑上直接打开浏览器就能看，画质清晰流畅，片源也丰富。追剧神器，强烈推荐！',
    date: '2026-08-01',
  },
  {
    id: 't002',
    name: '王芳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%20warm%20lighting%20clean%20simple%20background%20gentle%20smile%20professional%20photography&width=80&height=80&seq=mv-test-002&orientation=squarish',
    role: '上班族',
    rating: 5,
    content: '午休时间刷剧简直不要太方便！不用下载不用安装，浏览器一开就能看。画中画模式简直是打工人的福音，边工作边追剧两不误。',
    date: '2026-07-28',
  },
  {
    id: 't003',
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%20warm%20lighting%20clean%20simple%20background%20confident%20smile%20professional%20photography&width=80&height=80&seq=mv-test-003&orientation=squarish',
    role: '大学生',
    rating: 5,
    content: '学校的电脑不让装软件，网页版完美解决。在图书馆用电脑看纪录片学习，在宿舍用手机浏览器追番，学习娱乐两不误，爱了爱了！',
    date: '2026-07-25',
  },
  {
    id: 't004',
    name: '陈静',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%20warm%20lighting%20clean%20simple%20background%20bright%20smile%20professional%20photography&width=80&height=80&seq=mv-test-004&orientation=squarish',
    role: '全职妈妈',
    rating: 4,
    content: '带娃间隙就想看点轻松的综艺放松一下。网页版操作简单，老年人也能轻松上手。短剧频道的内容特别适合碎片时间，一集几分钟刚刚好。',
    date: '2026-07-20',
  },
  {
    id: 't005',
    name: '刘强',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%20warm%20lighting%20clean%20simple%20background%20casual%20smile%20professional%20photography&width=80&height=80&seq=mv-test-005&orientation=squarish',
    role: 'IT工程师',
    rating: 5,
    content: '作为一个技术人员，蘑菇视频网页版的技术实现让我印象深刻。播放器性能优化做得很好，4K视频都能流畅播放，几乎不卡顿。加载速度也很快。',
    date: '2026-07-15',
  },
];